import { useEffect, useState } from "react";
import { Box, Button, useMediaQuery, useTheme } from "@mui/material";
import { Android } from "@mui/icons-material";
import { PLAY_STORE_URL } from "../config/store";
import { trackEvent } from "../utils/analytics";

/**
 * Subtle fixed bottom CTA on mobile; hides near final CTA / footer.
 */
const StickyPlayCta = ({ hideWhenSelector = "#final-cta" }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    if (!isMobile) return undefined;
    const target = document.querySelector(hideWhenSelector);
    if (!target || typeof IntersectionObserver === "undefined") return undefined;

    const observer = new IntersectionObserver(
      ([entry]) => setVisible(!entry.isIntersecting),
      { root: null, threshold: 0.15 },
    );
    observer.observe(target);
    return () => observer.disconnect();
  }, [isMobile, hideWhenSelector]);

  if (!isMobile || !visible) return null;

  return (
    <Box
      role="region"
      aria-label="Download Treasure"
      sx={{
        position: "fixed",
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: 30,
        px: 2,
        pb: "calc(12px + env(safe-area-inset-bottom))",
        pt: 1.25,
        background: "linear-gradient(180deg, rgba(247,245,251,0) 0%, rgba(247,245,251,0.96) 28%, #f7f5fb 100%)",
        pointerEvents: "none",
      }}
    >
      <Button
        fullWidth
        component="a"
        href={PLAY_STORE_URL}
        target="_blank"
        rel="noopener noreferrer"
        variant="contained"
        startIcon={<Android />}
        onClick={() => trackEvent("sticky_google_play_click")}
        sx={{
          pointerEvents: "auto",
          textTransform: "none",
          fontWeight: 700,
          borderRadius: 999,
          py: 1.25,
          boxShadow: "0 10px 28px rgba(94, 53, 177, 0.28)",
        }}
      >
        Get Treasure on Google Play
      </Button>
    </Box>
  );
};

export default StickyPlayCta;
